// (function($) {
  
  
//   // stx reorder 
//   this.reorder = new function(){
//     var self = this;
//     this.pushQueue = function(i, data, el){
//       //LOW STOCK -- add as many as possible if stock is below requested ammount
//       if(data[i].check_inventory){
//         data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
//       }
//       $.ajax({
//         url: '/cart/add.js',
//         method: 'POST',
//         data: {
//           quantity: data[i].quantity,
//           id: data[i].id
//         },
//         complete: function(res){
//           if(i >= data.length - 1){
//             //products from queue are now added to the cart -> stop loading signal and go to cart
//             el.removeClass('loading');
//             window.location.href = '/cart';
//             return;
//           }else{
//             // Calls are async as required by Shopify Docs
//                self.pushQueue(i+1, data, el);
//           }
//         }
//       });
//     }
//     this.listen = function(){
//       var el = $(this);
//       var ids = el.attr('data-variant-ids').split(',');
//       var quantities = el.attr('data-variant-quantities').split(',');
//       var inventories = el.attr('data-variant-inventories').split(',');
//       var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
//       var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
//       ids.splice(-1, 1);
//       quantities.splice(-1, 1);
//       inventories.splice(-1, 1);
//       inventory_policies.splice(-1, 1);
//       inventory_trackers.splice(-1, 1);
//       var data = [];
//       for(var i=0; i<ids.length; i++){
//         data.push({
//           id: ids[i],
//           quantity: quantities[i],
//           inventory: inventories[i],
//           check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
//         });
//       }
//       el.addClass('loading');
//       self.pushQueue(0, data, el);
//     }
//     this.init = function(){
//       $('.reorder-btn').on('click', self.listen);
//     }
//   }
//   $(reorder.init);
 
  
// })(jQuery)



(function () {
  'use strict';

  console.log('=================================');
  console.log('REORDER SCRIPT LOADED');
  console.log('=================================');

  function setupReorder() {

    console.log('Reorder setup started');

    document.addEventListener('click', function (event) {

      var button = event.target.closest('.reorder-btn');

      if (!button) {
        return;
      }

      console.log('=================================');
      console.log('REORDER BUTTON CLICKED');
      console.log('=================================');

      event.preventDefault();
      event.stopPropagation();

      /*
       * Prevent multiple clicks
       */
      if (button.classList.contains('loading')) {
        console.log('Reorder already in progress');
        return;
      }

      /*
       * Get data attributes
       */
      var variantIds =
        button.getAttribute('data-variant-ids') || '';

      var quantities =
        button.getAttribute('data-variant-quantities') || '';

      var inventories =
        button.getAttribute('data-variant-inventories') || '';

      var inventoryPolicies =
        button.getAttribute('data-variant-inventory-policies') || '';

      var inventoryTrackers =
        button.getAttribute('data-variant-inventory-trackers') || '';

      console.log('Variant IDs:', variantIds);
      console.log('Quantities:', quantities);
      console.log('Inventories:', inventories);
      console.log('Policies:', inventoryPolicies);
      console.log('Trackers:', inventoryTrackers);

      /*
       * Convert comma separated values into arrays
       */
      var ids = variantIds
        .split(',')
        .map(function (value) {
          return value.trim();
        })
        .filter(function (value) {
          return value !== '';
        });

      var qtys = quantities
        .split(',')
        .map(function (value) {
          return value.trim();
        });

      var invs = inventories
        .split(',')
        .map(function (value) {
          return value.trim();
        });

      var policies = inventoryPolicies
        .split(',')
        .map(function (value) {
          return value.trim();
        });

      var trackers = inventoryTrackers
        .split(',')
        .map(function (value) {
          return value.trim();
        });

      console.log('Parsed IDs:', ids);

      /*
       * Make sure we have products
       */
      if (ids.length === 0) {

        console.error(
          'REORDER ERROR: No variant IDs found.'
        );

        alert('No product was found to reorder.');

        return;
      }

      /*
       * Build Shopify cart items
       */
      var items = [];

      for (var i = 0; i < ids.length; i++) {

        var variantId = parseInt(ids[i], 10);

        var requestedQuantity =
          parseInt(qtys[i], 10) || 0;

        var inventory =
          parseInt(invs[i], 10) || 0;

        var policy =
          policies[i] || '';

        var tracker =
          trackers[i] || '';

        var finalQuantity =
          requestedQuantity;

        /*
         * Only restrict quantity when:
         *
         * inventory policy = deny
         * AND inventory tracking is enabled
         */
        if (
          policy === 'deny' &&
          tracker !== ''
        ) {

          finalQuantity = Math.min(
            requestedQuantity,
            inventory
          );

        }

        console.log(
          'Product ' + (i + 1),
          {
            variantId: variantId,
            requestedQuantity: requestedQuantity,
            inventory: inventory,
            policy: policy,
            tracker: tracker,
            finalQuantity: finalQuantity
          }
        );

        /*
         * Ignore invalid products
         */
        if (
          !variantId ||
          finalQuantity <= 0
        ) {
          console.warn(
            'Skipping invalid product:',
            variantId
          );

          continue;
        }

        items.push({
          id: variantId,
          quantity: finalQuantity
        });
      }

      /*
       * No valid items
       */
      if (items.length === 0) {

        console.error(
          'REORDER ERROR: No valid items to add.'
        );

        alert(
          'This product is currently unavailable for reorder.'
        );

        return;
      }

      console.log(
        'FINAL SHOPIFY ITEMS:',
        items
      );

      /*
       * Add loading class
       */
      button.classList.add('loading');

      /*
       * Shopify AJAX Cart API
       */
      console.log(
        'Sending request to /cart/add.js'
      );

      fetch(
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({
            items: items
          })
        }
      )

      .then(function (response) {

        console.log(
          'Cart API status:',
          response.status
        );

        return response.text().then(function (text) {

          var data = {};

          try {
            data = text ? JSON.parse(text) : {};
          } catch (error) {

            console.error(
              'Could not parse Shopify response:',
              text
            );

          }

          if (!response.ok) {

            console.error(
              'Shopify returned an error:',
              data
            );

            throw new Error(
              data.description ||
              data.message ||
              'Shopify could not add this product.'
            );
          }

          return data;

        });

      })

      .then(function (data) {

        console.log(
          '================================='
        );

        console.log(
          'REORDER SUCCESSFUL'
        );

        console.log(
          'Shopify response:',
          data
        );

        console.log(
          '================================='
        );

        /*
         * Redirect to cart
         */
        window.location.href = '/cart';

      })

      .catch(function (error) {

        console.error(
          '================================='
        );

        console.error(
          'REORDER FAILED'
        );

        console.error(
          error
        );

        console.error(
          '================================='
        );

        button.classList.remove('loading');

        alert(
          error.message ||
          'Something went wrong while reordering.'
        );

      });

    }, true);

    console.log(
      'Reorder click listener attached'
    );
  }

  /*
   * Make sure DOM is ready
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      setupReorder
    );

  } else {

    setupReorder();

  }

})();